import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode, Transition as _Transition, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { id: "app" }
const _hoisted_2 = {
  key: 0,
  class: "github-navbar"
}
const _hoisted_3 = { class: "navbar-left" }
const _hoisted_4 = {
  width: "28",
  height: "28",
  viewBox: "0 0 24 24",
  style: {"vertical-align":"middle","margin-right":"8px"}
}
const _hoisted_5 = { class: "navbar-title" }
const _hoisted_6 = { class: "navbar-menu desktop-menu" }
const _hoisted_7 = { class: "drawer-header" }
const _hoisted_8 = { class: "drawer-menu-ul" }

import { ref, onMounted, computed, watch } from "vue";
import { useRoute } from "vue-router";


export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const route = useRoute();

const roteMeta = ref(route.meta);

//监听路由变化，获取路由mate
watch(
  () => route.meta,
  (newMeta) => (roteMeta.value = newMeta),
  { immediate: true }
);

const menuItems = [
  {
    name: "隐私政策摘要",
    path: "/privacy_policy_brief",
    title: "隐私政策摘要",
  },
  { name: "用户协议", path: "/user_agreement", title: "用户协议" },
  { name: "隐私政策", path: "/privacy_policy", title: "隐私政策" },
  { name: "权限说明", path: "/permission_description", title: "权限说明" },
  { name: "SDK说明", path: "/SDK", title: "SDK说明" },
  {
    name: "个人信息收集清单",
    path: "/personal_information",
    title: "个人信息收集清单",
  },
  { name: "常见问题解答", path: "/faq", title: "常见问题解答" },
];

const pageTitle = computed(() => {
  const found = menuItems.find((item) => item.path === route.path);
  return found ? found.title : "政律通";
});

const theme = ref("light");
const drawerOpen = ref(false);

const setTheme = (t: string) => {
  theme.value = t;
  if (t === "dark") {
    document.documentElement.style.setProperty("--background-color", "#181a1b");
    document.documentElement.style.setProperty("--text-color", "#c9d1d9");
    document.documentElement.style.setProperty("--navbar-bg", "#161b22");
    document.documentElement.style.setProperty("--navbar-border", "#21262d");
    document.documentElement.style.setProperty("--table-border-color", "#333");
    document.documentElement.style.setProperty("--table-head-color", "#1e1e1e");
    // FAQ 暗色变量
    document.documentElement.style.setProperty("--faq-title-color", "#e6edf3");
    document.documentElement.style.setProperty("--faq-input-bg", "#23272f");
    document.documentElement.style.setProperty("--faq-input-color", "#e6edf3");
    document.documentElement.style.setProperty("--faq-list-bg", "#23272f");
    document.documentElement.style.setProperty(
      "--faq-group-toggle-bg",
      "#23272f"
    );
    document.documentElement.style.setProperty("--faq-li-bg", "#23272f");
    document.documentElement.style.setProperty("--no-results-bg", "#23272f");
    document.documentElement.style.setProperty(
      "--no-results-title-color",
      "#58a6ff"
    );
  } else {
    document.documentElement.style.setProperty("--background-color", "#ffffff");
    document.documentElement.style.setProperty("--text-color", "#24292f");
    document.documentElement.style.setProperty("--navbar-bg", "#f6f8fa");
    document.documentElement.style.setProperty("--navbar-border", "#d8dee4");
    document.documentElement.style.setProperty("--table-border-color", "#ccc");
    document.documentElement.style.setProperty("--table-head-color", "#d0e8f3");
    // FAQ 亮色变量
    document.documentElement.style.setProperty("--faq-title-color", "#24292f");
    document.documentElement.style.setProperty("--faq-input-bg", "#fff");
    document.documentElement.style.setProperty("--faq-input-color", "#24292f");
    document.documentElement.style.setProperty("--faq-list-bg", "#f6f8fa");
    document.documentElement.style.setProperty(
      "--faq-group-toggle-bg",
      "#f6f8fa"
    );
    document.documentElement.style.setProperty("--faq-li-bg", "#fff");
    document.documentElement.style.setProperty("--no-results-bg", "#fff");
    document.documentElement.style.setProperty(
      "--no-results-title-color",
      "#2188ff"
    );
  }
};

onMounted(() => {
  setTheme("light");
  window.setTheme = setTheme;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!roteMeta.value.noHeader)
      ? (_openBlock(), _createElementBlock("nav", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("button", {
              class: "menu-btn mobile-menu",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (drawerOpen.value = true))
            }, [
              (_openBlock(), _createElementBlock("svg", _hoisted_4, [...(_cache[6] || (_cache[6] = [
                _createElementVNode("path", {
                  fill: "currentColor",
                  d: "M3 6h18v2H3V6m0 5h18v2H3v-2m0 5h18v2H3v-2z"
                }, null, -1)
              ]))]))
            ]),
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Logo",
              class: "navbar-logo",
              draggable: "false",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push('/')))
            }),
            _createElementVNode("span", _hoisted_5, _toDisplayString(pageTitle.value), 1),
            _createElementVNode("ul", _hoisted_6, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                return _createElementVNode("li", {
                  key: item.path
                }, [
                  _createVNode(_component_router_link, {
                    to: item.path
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(item.name), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"])
                ])
              }), 64))
            ])
          ]),
          _createVNode(_Transition, { name: "drawer" }, {
            default: _withCtx(() => [
              (drawerOpen.value)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "drawer-overlay mobile-menu",
                    onClick: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (drawerOpen.value = false), ["self"]))
                  }, [
                    _createElementVNode("div", {
                      class: "drawer-menu",
                      onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
                    }, [
                      _createElementVNode("div", _hoisted_7, [
                        _cache[7] || (_cache[7] = _createElementVNode("span", null, "菜单", -1)),
                        _createElementVNode("button", {
                          class: "drawer-close",
                          onClick: _cache[2] || (_cache[2] = ($event: any) => (drawerOpen.value = false))
                        }, " ✕ ")
                      ]),
                      _createElementVNode("ul", _hoisted_8, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menuItems, (item) => {
                          return _createElementVNode("li", {
                            key: item.path
                          }, [
                            _createVNode(_component_router_link, {
                              to: item.path,
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (drawerOpen.value = false))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(item.name), 1)
                              ]),
                              _: 2
                            }, 1032, ["to"])
                          ])
                        }), 64))
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_router_view, null, {
      default: _withCtx(({ Component, route }) => [
        _createVNode(_Transition, {
          name: "fade-slide",
          mode: "out-in"
        }, {
          default: _withCtx(() => [
            (_openBlock(), _createBlock(_resolveDynamicComponent(Component), {
              key: route.fullPath
            }))
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    })
  ]))
}
}

})